import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Footer } from './main-side/Footer';
import { Header } from './main-side/Header';
import './App.css';
import { updateSeo } from './seo';

export const Template = ({ children }: PropsWithChildren) => {
  const { pathname } = useLocation();
  useEffect(() => {
    updateSeo(pathname);
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="App"><a className="skip-link" href="#main-content">Skip to content</a><Header /><main id="main-content" tabIndex={-1}>{children}</main><Footer /></div>;
};
